export default __webpack_public_path__ + "static/media/button-green.d334fb55.png";